import React, { FunctionComponent } from "react";
import { ListItemIcon, Menu, MenuItem, MenuProps, useTheme } from "@mui/material";
import { strings } from "../../../localization/LocalizedStrings";
import { Icon } from "../../../icons/Icon";
import { IconType } from "../../../icons/IconType";

export const LayoutOptionsMenu: FunctionComponent<ILayoutOptionsMenuProps> = ({
  menuProps,
  handleMenuClose,
  onModify,
  onDelete,
  setIsSelectOpen
}) => {
  const theme = useTheme();
  return (
    <div onClick={event => event.stopPropagation()}>
      <Menu {...menuProps}>
        <MenuItem
          key={"Modify"}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            handleMenuClose();
            setIsSelectOpen(false);
            onModify();
          }}
          dense
        >
          <ListItemIcon>
            <Icon type={IconType.EditSquare} />
          </ListItemIcon>
          {strings.alert_modify}
        </MenuItem>
        <MenuItem
          key={"Remove"}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            handleMenuClose();
            setIsSelectOpen(false);
            onDelete();
          }}
          sx={{ color: theme.palette.colors?.remove }}
          dense
        >
          <ListItemIcon sx={{ color: theme.palette.colors?.remove }}>
            <Icon type={IconType.DeleteForever} />
          </ListItemIcon>
          {strings.alert_delete}
        </MenuItem>
      </Menu>
    </div>
  );
};

interface ILayoutOptionsMenuProps {
  menuProps: MenuProps;
  handleMenuClose: () => void;
  onModify: () => void;
  onDelete: () => void;
  setIsSelectOpen: (isSelectOpen: boolean) => void;
}
